import templateUrl from "emun.auth/address-fieldset.htm";

export class controller {
  $onInit() {
    if (!this.colSplit) this.colSplit = 4;
  }
}

export default {
  bindings: {
    bus: "<",
    showCompanyName: "<",
    showPhone: "<",
    showFax: "<",
    colSplit: "@",
    request: "=ngModel"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
